export default "__VITE_ASSET__BWTAxOU$__"